<template>

<core-modal v-on:close="onClose" :nopadding="true" icon="caret-left">

	<template v-slot:head>

		Create View

	</template>

	<template v-slot:default>

        <core-modal-inputs>

            <core-input-textbox v-model="model.name" placeholder="Enter name" />

        </core-modal-inputs>

		<com-type v-model="model.type" />
		<com-public v-model="model.public" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!model.name" v-on:click.native="onConfirmClick">Confirm</core-button>

	</template>

</core-modal>

</template>

<script>

import mixValidation from 'core/mixin/modal/Validation'

import comType from './create/Type'
import comPublic from './create/Public'

export default {

	mixins: [mixValidation],

	props: ['data'],

    components: {
        comType,
        comPublic
    },

	data: function() {

		return {

			is: {
				loading: false
			},

			model: {
				name: '',
				type: 1,
				public: 1,
				context: 0,
				fields: []
			},

			validation: {
				name: {
					exists: true,
					max: 16
				}
			}

		}

	},

	created: function() {

		if (this.$currentViewContext === 'collection') this.model.context = 1
		if (this.$currentViewContext === 'ratings') this.model.context = 2
		if (this.$currentViewContext === 'plays') this.model.context = 3
		if (this.$currentViewContext === 'gameplays') this.model.context = 4

	},

	methods: {

        onConfirmClick: function() {

			this.is.loading = true

            this.$api.post('views/create', {
				data: this.model
			}).then(function(view) {

				this.$store.commit('data/views/add', [view])

				this.$emit('close')

				this.$pubsub.$emit('open.modal', {
					id: 'viewsView',
					view: view.id
				})

			}.bind(this), function() {

				this.is.error = true
				this.is.loading = false

			}.bind(this)) 	

        },

		onClose: function() {

			this.$emit('close')

            this.$pubsub.$emit('open.modal', {
				id: 'viewsManage'
			})

		}

	}

}

</script>

<style scoped>

</style>